import { ReducerData } from '../rootReducer';
import { SourceType } from './types';

export function selectSessionList(state: ReducerData) {
	return state.sessions.list.filter(
		item =>
			item.sessionSource !== SourceType.SupportTicket &&
			item.sessionSource !== SourceType.Accounts &&
			item.sessionSource !== SourceType.History &&
			item.sessionSource !== SourceType.InternalApp,
	);
}
export function selectLookUpSessionList(state: ReducerData) {
	return state.sessions.list.filter(
		item =>
			item.sessionSource === SourceType.SupportTicket ||
			item.sessionSource === SourceType.Accounts ||
			item.sessionSource === SourceType.History ||
			item.sessionSource === SourceType.InternalApp,
	);
}

export function selectSessionNotification(state: ReducerData) {
	return state.sessions.sessionNotification;
}

export function selectCurrentAccountsProfilePk(state: ReducerData) {
	return state.sessions.currentAccounts.profilePk;
}

export function selectCurrentAccountsProfileFirstName(state: ReducerData) {
	return state.sessions.currentAccounts.firstName;
}

export function selectCurrentAccounts(state: ReducerData) {
	return state.sessions.currentAccounts.accounts;
}

export function selectCurrentCaspioId(state: ReducerData) {
	const { primaryEmail, statuses } = state.sessions.currentAccounts;
	return { primaryEmail, statuses };
}

export function selectSessionState(state: ReducerData) {
	return state.sessions.selected.state;
}

export function selectCurrentSessionId(state: ReducerData) {
	return state.sessions.selected.sessionId;
}

export function selectCurrentSessionAccountsViewed(state: ReducerData) {
	return state.sessions.currentAccounts.viewed;
}
